import { render, staticRenderFns } from "./sign-attributes.vue?vue&type=template&id=145cfc3a"
import script from "./sign-attributes.vue?vue&type=script&lang=js"
export * from "./sign-attributes.vue?vue&type=script&lang=js"
import style0 from "./sign-attributes.vue?vue&type=style&index=0&id=145cfc3a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports